import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/lmr/customerProfileUpdate`;
const _api_customer_search_api_url = `${BASE_URL}/lmr/customerSearch`;

interface parameter {
  payload: {
    mobileNo: string;
    customer_Name: string;
    email: string;
    date_Of_Birth: string;
    gender: string;
    pincode: string;
  };
  accessToken: string;
}
interface ReqPayload {
  payload: {
    source: string;
    locationCode: string;
    mobileNumber: string | null;
  };
  accessToken: string;
}
interface UpdateProfileResponse {
  result: boolean;
  resultCode: string;
  message: string;
  updateMsg: string;
}
interface CustomerSearchResponse {
  result: boolean;
  resultCode: string;
  message: string;
  updateMsg: string;
  firstName: string;
  tier: string;
  pointsAvailable: number;
  pointToExpire: number;
  cardNumber: string;
  email: string;
  gender: string;
  dob: string;
  lastName: string | null;
  sbiPointBal:number;
}

// test user fetch.
// TODO: remove later
export const updateProfileApi = async (
  updatData: parameter,
): Promise<UpdateProfileResponse[]> => {
  try {
    const response = await httpClient.post(_api_base_url, updatData.payload, {
      headers: {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${updatData.accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const getCustomerProfile = async (
  parameters: ReqPayload,
): Promise<CustomerSearchResponse> => {
  try {
    const response = await httpClient.post(
      _api_customer_search_api_url,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
